import React from "react";
import "./Cancel.css"
const CancelPara = () => {
  return (
    <div className="cancelParaContainer">
      <ul>
        <li>
          Orders placed through www.bouncehere.com cannot be cancelled, and no
          refunds will be issued once an order has been successfully placed
          through www.scentlifestyle.com.
        </li>
        <li>
          If you need to make changes to your order, please call our customer
          support at +9197402 22700 as soon as possible, and we will do our best
          to accommodate your request.
        </li>
        <li>
          For further inquiries, please contact us at info@scentlifestyle.com
        </li>
      </ul>
    </div>
  );
};

export default CancelPara;
